import { fetchApi } from '@/config/axiosSetting';
import {
  WalletSettlementFilesQueryParamsType,
  WalletSettlementFilesQueryResponseType,
} from './walletSettlementFilesQuery.type';

export const walletSettlementFilesFunction = (
  params: WalletSettlementFilesQueryParamsType,
): Promise<WalletSettlementFilesQueryResponseType> => {
  return fetchApi.get(`financial/settlements/${params.settlementId}/files/`);
};
